<template>
  <div class="sidebar-menu">
    <div v-for="item in menu" :key="item.id" class="menu-section">
      <div class="menu-title">{{ item.title }}</div>
      <div class="submenu">
        <router-link
          v-for="subItem in item.children"
          :key="subItem.id"
          :to="subItem.path"
          class="menu-item"
          active-class="active"
        >
          {{ subItem.title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TutorialSidebar',
  props: {
    menu: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.sidebar-menu {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.menu-title {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: var(--adil-fontcolor);
}

.submenu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.menu-item {
  padding: 8px 12px;
  border-radius: 6px;
  color: var(--adil-secondtext);
  text-decoration: none;
  transition: all 0.3s;
}

.menu-item:hover {
  background: var(--adil-secondbg);
  color: var(--adil-fontcolor);
}

.menu-item.active {
  background: var(--adil-theme);
  color: white;
}
</style> 